import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import branch from 'client/core/branch';
import { makeProxiedS3FilePath } from 'client/lib/fileUploader';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';
import ButtonDeprecated, {
  BUTTON_THEME_WHITE,
} from 'client/components/ButtonDeprecated';
import SrFormikField from 'client/components/SrFormikField';

@branch({
  appUrl: ['env', 'APP_URL'],
})
class SrHouseholdApplicationPhotoFieldViewer extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    appUrl: PropTypes.string.isRequired,
    application: PropTypes.object.isRequired,
    photoFieldId: PropTypes.string.isRequired,
    filePath: PropTypes.string.isRequired,
    onUpdate: PropTypes.func.isRequired,
    isBusy: PropTypes.bool,
  }

  _onDeletePhoto = (photoUrl) => {
    const { application, photoFieldId, onUpdate } = this.props;
    const photoFieldValue = application[photoFieldId].filter((pUrl) => pUrl !== photoUrl);

    onUpdate({
      application,
      photoFieldId,
      photoFieldValue,
    });
  }

  _onAddPhotos = (formValues) => {
    const { application, photoFieldId, onUpdate } = this.props;
    const photoFieldValue = formValues[photoFieldId];

    if (!photoFieldValue.length) {
      return;
    }

    onUpdate({
      application,
      photoFieldId,
      photoFieldValue: [
        ...(application[photoFieldId] || []),
        ...photoFieldValue,
      ],
    });
  }

  render() {
    const {
      title,
      application,
      photoFieldId,
      filePath,
      appUrl,
      isBusy,
    } = this.props;

    const photos = (application[photoFieldId] || []);

    return (
      <SrBox>
        <SrText weight='bold'>{title}</SrText>
        {photos.map((photo) => {
          const photoUrl = makeProxiedS3FilePath(photo, appUrl);
          return (
            <SrBox key={photoUrl} position='relative'>
              <SrBox position='absolute' top={20} right={20}>
                <ButtonDeprecated
                  theme={BUTTON_THEME_WHITE}
                  className='small-admin'
                  onClick={() => this._onDeletePhoto(photo)}
                >
                  delete
                </ButtonDeprecated>
              </SrBox>
              <SrBox
                className='uploadedThumbnail'
                backgroundImage={`url("${photoUrl}")`}
                bgRepeat='no'
                height={300}
              />
              <SrLink target='_blank' to={photoUrl}>
                <SrText weight='bold'>Download: </SrText>
                <SrText color='blue300'>{photoUrl}</SrText>
              </SrLink>
            </SrBox>
          );
        })}

        <Formik
          enableReinitialize
          initialValues={{
            [photoFieldId]: [],
          }}
          onSubmit={this._onAddPhotos}
          render={(formikBag) => (
            <Form>
              <SrFormikField
                formikBag={formikBag}
                formField={{
                  id: photoFieldId,
                  label: '',
                  validations: ['required'],
                  type: 'file_multi',
                  properties: {
                    fileAccept: '*',
                    filePath: filePath,
                    isPrivate: true,
                    uploadAs: application.userId,
                  },
                }}
              />
              <ButtonDeprecated type='submit' disabled={isBusy}>
                {isBusy ? 'uploading...' : 'upload'}
              </ButtonDeprecated>
            </Form>
          )}
        />
      </SrBox>
    );
  }
}

SrHouseholdApplicationPhotoFieldViewer.displayName = 'SrHouseholdApplicationPhotoFieldViewer';

export default SrHouseholdApplicationPhotoFieldViewer;
